const videoUploadSize = 256

document.addEventListener('turbolinks:load', function () {
  $(document).on('change', 'input:file#content_upload', function () {
    const validFileTypes = ['video/mp4', 'video/mkv', 'video/mov', 'application/pdf']
    for (let i = 0; i < this.files.length; i++) {
      if (this.files && this.files[i]) {
        if (this.files[i].size / (1000 * 1000 * 1000) > videoUploadSize && !validFileTypes.includes(this.files[i].type)) {
          $('#content_upload').val('')
          $('#property-content-error').html('Aïe, cette vidéo est vraiment très lourde, elle ne sera pas acceptée sur les réseaux sociaux ! Réessayez avec une vidéo d’une taille maximale de' + videoUploadSize + ' Gb.')
          return false
        } else {
          $('#property-content-error').html('')
        }
      }
    }

    $('div#upload-content-modal').modal('toggle')
  })

  $(document).on('change', '.upload-content-modal input[type=radio]', function () {
    $('.upload-content-modal .upload-content-button.disabled').removeClass('disabled')
  })

  $(document).on('keyup', '.name-action input', function () {
    $('.btn.disabled', $(this).closest('.name-action')).removeClass('disabled')
  })
})
